// @Version: 1.0.0
import { Injectable } from "@angular/core";
import { FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import moment from "moment";
import { DATEFORMAT, DATEFORMATCALENDER, FC_DATE, RELATIVEDATEFORMAT } from "./date.model";
import { IFieldItem, VALIDATORS } from "../field-item.model";


@Injectable({
    providedIn: 'root'
})

export class CustomValidatorsDate {

   constructor () { }

   public isValid (fg: FormGroup, item: IFieldItem, dateFormat: DATEFORMATCALENDER): ValidatorFn {
      let today = new Date();
      return (): ValidationErrors | null => {
         if (!fg.dirty || !fg.get(FC_DATE.DATE)?.value) return null;
         if (item.valid == VALIDATORS.past) return fg.get(FC_DATE.DATE)?.value < today ?  null : { [VALIDATORS.past]: true };
         if (item.valid == VALIDATORS.future) return fg.get(FC_DATE.DATE)?.value > today ?  null : { [VALIDATORS.future]: true };
         if (item.valid == VALIDATORS.range) return fg.get(FC_DATE.DATE)?.value > new Date(moment(<string>item.attribute_3, DATEFORMAT.DE).format(DATEFORMAT.MONTH_DAY)) && fg.get(FC_DATE.DATE)?.value < new Date(moment(<string>item.attribute_4, DATEFORMAT.DE).format(DATEFORMAT.MONTH_DAY)) ?  null : { [VALIDATORS.range]: true }; 
         if (item.valid == VALIDATORS.relative) return this.isValidRelative(fg, item, dateFormat); 

         return null;
      }
   }

   private isValidRelative (fg: FormGroup, item: IFieldItem, dateFormat: DATEFORMATCALENDER): ValidationErrors | null {
      let attr3 = moment();
      let attr4 = moment();
      if (dateFormat == DATEFORMATCALENDER.YEAR) {
         attr3.set({date: 1, month: 0});
         attr4.set({date: 1, month: 0});
      }
      if (dateFormat == DATEFORMATCALENDER.MONTHYEAR) {
         attr3.set({date: 1});
         attr4.set({date: 1});
      }
    
      if (item.attribute_3 != "" && item.attribute_3 != null && item.attribute_4 != "" && item.attribute_4 != null) {
         if (item.attribute_6 == RELATIVEDATEFORMAT.DAY.toString()) return moment(fg.get(FC_DATE.DATE)?.value).isBetween(attr3.add(Number(item.attribute_3), 'days'), attr4.add(Number(item.attribute_4), 'days'), 'days', '[]') ?  null : { [VALIDATORS.relative]: true };
         if (item.attribute_6 == RELATIVEDATEFORMAT.MONTH.toString()) return moment(fg.get(FC_DATE.DATE)?.value).isBetween(attr3.add(Number(item.attribute_3), 'months'), attr4.add(Number(item.attribute_4), 'months'), 'days', '[]') ?  null : { [VALIDATORS.relative]: true };
         if (item.attribute_6 == RELATIVEDATEFORMAT.YEAR.toString()) return moment(fg.get(FC_DATE.DATE)?.value).isBetween(attr3.add(Number(item.attribute_3), 'years'), attr4.add(Number(item.attribute_4), 'years'), 'days', '[]') ? null : { [VALIDATORS.relative]: true };
      }

      return null;
   }
}